/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash/get';

import Button from '../Button';
import * as Styled from './styles';
import config from '../../constants/configs';
import CustomTooltip from '../CustomTooltip';

const onGearClick = (isEnabled) => {
    if (isEnabled) {
        window.open(config.memberSiteBrandingUrl, '_blank');
    }
};

const ColorPickerComponentCustomization = ({ showGearIcon, isEnabled }) => (
    <Styled.CustomizationContainer>
        <Styled.LabelContainer>
            <span>CUSTOM</span>
        </Styled.LabelContainer>
        <Styled.ButtonContainer>
            {showGearIcon ? (
                <Styled.GearContainer data-tip data-for="editCustomizationGear" id="customization-gear">
                    <Button
                        label={isEnabled ? "Edit your organization's branding settings." : ''}
                        type="simple"
                        width={18}
                        icon="cog"
                        iconSize={16}
                        marginBottom={0}
                        iconPadding={1}
                        color={isEnabled ? '#656566' : '#CCCCCC'}
                        cursor={isEnabled ? 'pointer' : 'not-allowed'}
                        tooltipPosition="top"
                        hasHoverEffects={false}
                        onClick={() => onGearClick(isEnabled)}
                    />
                </Styled.GearContainer>
            ) : (
                <Button
                    label="Branding can only be accessed by your account Administrator through app.bananatag.com"
                    type="simple"
                    width={18}
                    icon="cog"
                    iconSize={16}
                    iconPadding={1}
                    color="#CCCCCC"
                    tooltipPosition="top"
                    cursor="default"
                    hasHoverEffects={false}
                />
            )}
            {!isEnabled && (
                <CustomTooltip
                    dataRef="editCustomizationGear"
                    offset={{ right: -45, bottom: -158 }}
                    width={135}
                    text="Set branding colors for your whole team to use. Book a demo to learn more."
                />
            )}
        </Styled.ButtonContainer>
    </Styled.CustomizationContainer>
);

ColorPickerComponentCustomization.propTypes = {
    isEnabled: PropTypes.bool.isRequired,
    showGearIcon: PropTypes.bool.isRequired,
};

const ColorPickerComponent = ({
    type,
    enableGearIcon,
    disableAlpha,
    color,
    presetColors,
    onChangeComplete,
    width,
    showGearIcon,
}) => {
    switch (type) {
        case 'simple':
            return (
                <Styled.BlockPicker
                    triangle="hide"
                    colors={presetColors.map((item) => item.color)}
                    onChangeComplete={onChangeComplete}
                    width={180}
                    data-test-id="simple-color-picker"
                />
            );
        case 'default':
            return (
                <>
                    <Styled.SketchPicker
                        disableAlpha={disableAlpha}
                        color={color}
                        presetColors={presetColors}
                        onChangeComplete={onChangeComplete}
                        width={width}
                        className={width === 160 && 'block-btn-picker'}
                    />
                </>
            );
        case 'custom':
            return (
                <>
                    <Styled.CustomSketchPicker
                        disableAlpha={disableAlpha}
                        color={color}
                        presetColors={presetColors}
                        onChangeComplete={onChangeComplete}
                        width={width}
                        className={width === 160 && 'block-btn-picker'}
                    />
                    <ColorPickerComponentCustomization isEnabled={enableGearIcon} showGearIcon={showGearIcon} />
                </>
            );
        default:
            return null;
    }
};

ColorPickerComponent.defaultProps = {
    type: 'default',
    enableGearIcon: false,
    disableAlpha: false,
    width: 200,
    showGearIcon: false,
};

ColorPickerComponent.propTypes = {
    type: PropTypes.string,
    enableGearIcon: PropTypes.bool,
    disableAlpha: PropTypes.bool,
    color: PropTypes.string.isRequired,
    presetColors: PropTypes.array.isRequired,
    onChangeComplete: PropTypes.func.isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    showGearIcon: PropTypes.bool,
};

const ColorPicker = ({
    hasFullStylingAccess,
    hasCustomizationFeature,
    hasCustomizationAccess,
    disableAlpha,
    color,
    presetColors,
    onChangeComplete,
    width,
    sessionFeatures,
}) => {
    const colorPickerComponentProps = {
        disableAlpha,
        color,
        presetColors,
        onChangeComplete,
        width,
    };
    const { F_COLOR_PALETTE } = sessionFeatures;
    const useCustomizedColorPicker = !F_COLOR_PALETTE || hasCustomizationFeature;
    const showGearIcon = !F_COLOR_PALETTE || hasCustomizationAccess;
    if (!hasFullStylingAccess) {
        return <ColorPickerComponent type="simple" {...colorPickerComponentProps} />;
    }

    return useCustomizedColorPicker ? (
        <ColorPickerComponent
            type="custom"
            showGearIcon={showGearIcon}
            enableGearIcon={F_COLOR_PALETTE}
            {...colorPickerComponentProps}
        />
    ) : (
        <ColorPickerComponent type="default" {...colorPickerComponentProps} />
    );
};

const mapStateToProps = (state) => ({
    sessionFeatures: _get(state, 'session.features', {}),
});

ColorPicker.defaultProps = {
    hasFullStylingAccess: false,
    hasCustomizationFeature: false,
    hasCustomizationAccess: false,
    disableAlpha: false,
    width: 200,
};

ColorPicker.propTypes = {
    hasFullStylingAccess: PropTypes.bool,
    hasCustomizationFeature: PropTypes.bool,
    hasCustomizationAccess: PropTypes.bool,
    disableAlpha: PropTypes.bool,
    color: PropTypes.string.isRequired,
    presetColors: PropTypes.array.isRequired,
    onChangeComplete: PropTypes.func.isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sessionFeatures: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(ColorPicker);
